<template>
  <div class="nd-page">
    <header class="nd-page-header">
      <div>
        <span id="title" class="page-title">{{ id ? "Editar Convênio" : "Novo Convênio" }}</span>
        <div class="nd-page-kicker">
          Mantenha a identificação da operadora padronizada para agenda, pacientes e atendimentos.
        </div>
      </div>

      <div class="button-group">
        <v-btn type="button" outlined color="primary" elevation="0" @click="$router.push('/convenios')">
          <v-icon left size="18">mdi-arrow-left</v-icon>
          Voltar
        </v-btn>
        <v-btn type="button" color="primary" elevation="0" @click="save" :loading="loadingSave">
          <v-icon left size="18">mdi-content-save-outline</v-icon>
          Salvar
        </v-btn>
      </div>
    </header>

    <v-card class="nd-section-card">
      <div class="nd-table-toolbar">
        <div>
          <div class="nd-table-toolbar__title">Dados do convênio</div>
          <div class="nd-table-toolbar__subtitle">Informações utilizadas nas rotinas administrativas</div>
        </div>
      </div>

      <v-form ref="form" v-model="formValid">
        <div class="nd-form-grid">
          <v-text-field
            label="Nome do convênio"
            v-model="name"
            :rules="[v => !!v || 'Campo obrigatório']"
            outlined
            dense
            autofocus
            hide-details="auto"
          />
        </div>

        <div class="nd-form-actions">
          <v-btn type="button" text color="primary" @click="$router.push('/convenios')">Cancelar</v-btn>
          <v-btn type="button" color="primary" elevation="0" @click="save" :loading="loadingSave">
            Salvar convênio
          </v-btn>
        </div>
      </v-form>
    </v-card>

    <v-overlay :value="loadingPage">
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "InsurancesDetails",

  data: () => ({
    id: null,
    name: "",
    formValid: false,
    loadingPage: false,
    loadingSave: false,
  }),

  async created() {
    const insuranceId = this.$route.params.id;
    if (insuranceId) {
      this.id = insuranceId;
      this.loadingPage = true;
      try {
        const response = await axios.get(`/insurance/${insuranceId}`);
        this.name = response.data.data.name;
      } catch (error) {
        this.$dialog.notify.error("Erro ao carregar convênio.", { position: "top-right", timeout: 5000 });
      } finally {
        this.loadingPage = false;
      }
    }
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.loadingSave = true;
      try {
        if (this.id) {
          await axios.patch(`/insurance/${this.id}`, { name: this.name });
          this.$dialog.notify.success("Convênio atualizado com sucesso!", { position: "top-right", timeout: 3000 });
        } else {
          const response = await axios.post("/insurance", { name: this.name });
          this.$dialog.notify.success("Convênio criado com sucesso!", { position: "top-right", timeout: 3000 });
          this.$router.replace(`/convenios/${response.data.data.id}`);
          this.id = response.data.data.id;
        }
      } catch (error) {
        this.$dialog.notify.error("Erro ao salvar convênio.", { position: "top-right", timeout: 5000 });
      } finally {
        this.loadingSave = false;
      }
    },
  },
};
</script>
